import { createRequestActionTypes } from '../../helpers'

export const FETCH_FOOTER_DATA = createRequestActionTypes(
  'FOOTER',
  'FETCH_FOOTER_DATA'
)



// WEBPACK FOOTER //
// ./src/containers/Footer/constants.js